import { Box, Button, Heading, Paragraph } from 'grommet'
import styled, { css } from 'styled-components'

const HEIGHT_MOBILE_FIELD_AND_BUTTON = 52

export const Wrapper = styled.form`
  z-index: 2;
  ${({ theme }) => theme.below.laptop`
    padding: 0px ${theme.newSpaces.xs}px;
  `}
`

export const ContentWrapper = styled(Box)`
  padding: 20px 0 0;
`

export const Title = styled(Heading)`
  ${({ theme }) => theme.getTypography('desktop', 'title', 'title2')}
  color: ${({ theme }) => theme.colors.white};
  margin-bottom: ${({ theme }) => theme.newSpaces.sm}px;
  max-width: ${({ maxTitleWidth }) =>
    maxTitleWidth ? `${maxTitleWidth}px` : '100%'};

  ${({ theme }) => theme.below.mobileXL`
      margin-bottom: ${theme.newSpaces.xs}px;
  `}
`

export const ButtonSubmit = styled(Button)`
  align-items: center;
  border: none;
  border-radius: 0px;
  display: flex;
  height: 50px;
  justify-content: center;
  position: relative;
  transition: all 0.2s ease-out 0s;

  ${({ theme, isSmallSubmiteButton }) => css`
    ${theme.getTypography('desktop', 'button', 'normal')}

    background-color: ${theme.newColors.accent};
    color: ${theme.newColors.white};
    margin-bottom: ${isSmallSubmiteButton ? `0 !important` : ''};
    margin-top: ${isSmallSubmiteButton
      ? `${theme.newSpaces.xs}px !important`
      : ''};
    max-width: ${isSmallSubmiteButton ? '150px !important' : '145px'};
    width: 100%;

    &:hover {
      box-shadow: none;

      &:after {
        background: ${theme.newColors.white};
        bottom: 12px;
        content: '';
        height: 2px;
        position: absolute;
        width: 45px;
      }
    }

    ${theme.below.mobileXL`
      max-width: 100%;
      height: ${HEIGHT_MOBILE_FIELD_AND_BUTTON}px;
    `}
  `}
`

export const InputWrapper = styled(Box)`
  align-items: flex-start;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 auto;
  width: 100%;

  ${({ theme, inOneLine }) => theme.below.mobileXL`
    ${
      inOneLine &&
      `
      flex-direction: column;

      button {
        width: 100%;
        margin-top: 16px;
        margin-bottom: 24px;
      }
    `
    }
  `}
`

export const InputContainer = styled(Box)`
  align-items: flex-end;
  margin-right: ${({ theme }) => theme.spaces[3]}px;
  width: 100%;
  & > input {
    background-color: white;
    border: none;
    border-radius: 0;
    box-shadow: none;
    font-size: ${({ theme }) => theme.fontSizes[14]}px;
    font-weight: ${({ theme }) => theme.fontWeight[2]};
    height: 50px;
    padding: 8px;
    padding-left: ${({ theme }) => theme.newSpaces.sm}px;
    width: 100%;
    outline: none;
    &:focus {
      box-shadow: none;
    }
  }
  & > p {
    color: ${({ theme }) => theme.newColors.errorGrayBG};
    margin-left: 0px;
    width: 100%;
  }

  ${({ theme }) => theme.below.mobileXL`
    & > input {
      height: ${HEIGHT_MOBILE_FIELD_AND_BUTTON}px;
    }
  `}
`

export const PersonInfo = styled(Box)`
  ${({ theme, inOneLine }) => css`
    margin-bottom: ${theme.newSpaces.xs}px;

    ${theme.below.mobileXL`
      ${
        inOneLine &&
        `
        flex-direction: row;
        margin-bottom: ${theme.newSpaces.sm}px;
      `
      }

    `}
  `}
`

export const PersonParagraph = styled(Paragraph)`
  color: ${({ theme, color }) => theme.colors[color]};
  display: inline-block;

  ${({ theme }) => theme.getTypography('desktop', 'body', 'body2')}

  span {
    display: block;
  }

  ${({ theme }) => theme.below.laptop`
    ${theme.getTypography('mobile', 'body', 'body2')}
  `}
`

export const SubmitedText = styled(Paragraph)`
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.fontSizes[5]}px;
  font-weight: ${({ theme }) => theme.fontWeight[5]};

  ${({ theme }) => theme.below.laptop`
    font-size: ${theme.fontSizes[4]}px;
  `}
`

export const Subtitle = styled(Paragraph)`
  ${({ theme }) => theme.getTypography('desktop', 'body', 'body2')}
  color: ${({ theme }) => theme.colors.white};
  margin-bottom: ${({ theme }) => theme.newSpaces.xl}px;
  max-width: 570px;
  text-align: left;
  width: 100%;

  ${({ theme }) => theme.below.laptop`
    ${theme.getTypography('mobile', 'body', 'body2')}

    ${theme.below.mobileXL`
      margin-bottom: ${theme.newSpaces.xs}px;
    `}
  `}
`
